import { login, logout, getInfo, getAccountId, loginLDAP } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, data) {
      const username = data.data.username.trim()
      return new Promise((resolve, reject) => {
        login(data.params, data.data)
          .then(response => {
            if (response.status === 200) {
              setToken(username)
              commit('SET_TOKEN', username)
              // Message({
              //   message: response.msg,
              //   type: 'success',
              //   duration: 5 * 1000
              // })
            }
            resolve(response)
            // const data = response.data
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    LoginLdap({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginLDAP(userInfo)
          .then(response => {
            if (response.status === 200) {
              setToken(username)
              commit('SET_TOKEN', username)
              // Message({
              //   message: response.msg,
              //   type: 'success',
              //   duration: 5 * 1000
              // })
            }
            resolve(response)
            // const data = response.data
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getAccountId()
          .then(data => {
            commit('SET_ROLES', data.currentCategory)
            commit('SET_NAME', data.displayName)
            commit('SET_AVATAR', data.avatarUrl)
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js